var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearchIconBig = function SvgSearchIconBig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.265 18.9a.635.635 0 0 1-.449-.187l-4.7-4.7-.07.055a6.077 6.077 0 0 1-3.8 1.319 6.152 6.152 0 0 1-6.145-6.145 6.152 6.152 0 0 1 6.145-6.144 6.151 6.151 0 0 1 6.144 6.144 6.086 6.086 0 0 1-1.318 3.8l-.055.07 4.7 4.7a.626.626 0 0 1 .187.449.626.626 0 0 1-.187.449.631.631 0 0 1-.452.19zM9.245 4.369a4.881 4.881 0 0 0-4.876 4.875 4.882 4.882 0 0 0 4.876 4.876 4.881 4.881 0 0 0 4.875-4.876 4.88 4.88 0 0 0-4.875-4.875z",
    "data-name": "Path 11602"
  })));
};
export default SvgSearchIconBig;